import { reactive, ref } from 'vue';

const enabled = ref(false);
const interaction = reactive({
    rotationCurrent: { x: 0, y: 0 },
    rotationTarget: { x: 0, y: 0 },
});

const activeOwners = new Map();
let currentOwner = null;

const selectLatestOwner = () => {
    const owners = [...activeOwners.keys()];
    currentOwner = owners[owners.length - 1] || null;
};

const setInteractionActive = (owner, label, active) => {
    if (active) {
        activeOwners.delete(owner);
        activeOwners.set(owner, { label });
        currentOwner = owner;
        return;
    }

    activeOwners.delete(owner);
    if (currentOwner === owner) selectLatestOwner();
};

const recordInteraction = (owner, snapshot) => {
    if (!enabled.value || owner !== currentOwner) return;

    interaction.rotationCurrent.x = snapshot.rotationCurrent.x;
    interaction.rotationCurrent.y = snapshot.rotationCurrent.y;
    interaction.rotationTarget.x = snapshot.rotationTarget.x;
    interaction.rotationTarget.y = snapshot.rotationTarget.y;
};

export const useInteractionDebug = () => ({
    enabled,
    interaction,
    recordInteraction,
    setInteractionActive,
});
